import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise"; 

import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";
import { Subject, throwError } from "rxjs";
import { FormDataDownloadType } from "../../temp-forms/temp-forms.component";

@Injectable()
export class TempModuleService {
    base_uri: string = "https://stgmformadminapi.dhwaniris.in/api/admin/v1/";
    private headers;
    private options;
    mapData;
    results;
    token = sessionStorage.getItem("token");
    project = sessionStorage.getItem("projectId");
    organisation = sessionStorage.getItem("organisationId");
    public afterMethodFileSelect: Subject<any> = new Subject();
    constructor(
        private httpClient: HttpClient,
        private http: Http,
        private router: Router,
        private auth: AuthService,
        @Inject('env') private env
    ) {
        this.base_uri = env.base_uri

    }
    copyForms(body) {
        return this.httpClient
            .post(
                `${this.base_uri}survey-form-builder/move-forms?destinationEnv=current`,
                body,
                this.auth.setHttpHeadersFormData()
            )
            .map((response: any) => response)
            .catch(this.handleError)
            .toPromise();
    }
    handleError(error: Response) {
        return throwError(error || "SERVER ERROR");
    }

    getForms(projectId: string = "") {
        return this.httpClient
            .get(
                `${this.base_uri}project-wise-forms?projectId=${projectId ? projectId : null}`,
                this.auth.setHttpHeaders()
            )
            .map((response) => response)
            .catch(this.handleError)
            .toPromise();
    }
    getProjects() {
        return this.http
            .get(this.base_uri + "project", this.auth.setHeaders())
            .map((response: Response) => response.json())
            .catch(this.handleError)
            .toPromise();
    }
    getFormDetails(formId: string = '', lng: string = "en") {
        return this.httpClient
            .get(
                `${this.base_uri}survey-form-builder/form-get/${formId}?language=${lng}`,
                this.auth.setHttpHeaders()
            )
            .map(response => response)
            .map(response => ({
                ...response,
                data: response['data'].map(question =>
                    this.mapSurveyorForms(question)
                )
            }))
            .toPromise();
    }
    private mapSurveyorForms(form: any) {
        return {
            ...form,
            language: this.setEnglishLanguageToZeroIndex(form.language)
        };
    }

    private setEnglishLanguageToZeroIndex(
        languageList: { lng: string; title: string; _id: string }[]
    ) {
        if (languageList.length < 2) {
            return languageList;
        }
        if (languageList.length && languageList[0].lng === 'en') {
            return languageList;
        }
        let newList = [...languageList];
        const englishLanguageIndex = newList.findIndex(
            language => language.lng === 'en'
        );
        if (englishLanguageIndex) {
            [newList[0], newList[englishLanguageIndex]] = [
                newList[englishLanguageIndex],
                newList[0]
            ];
        }
        return newList;
    }
    submitForm(_id: string) {
        return this.httpClient
            .get(
                `${this.base_uri}survey-form-builder/form-submit/${_id}`,
                this.auth.setHttpHeaders()
            )
            .map((response: any) => response)
            .catch(this.handlehttpError)
            .toPromise();
    }
    handlehttpError(request: HttpErrorResponse) {
        return throwError(request.error || 'SERVER ERROR');
    }

    downloadCSVOfForm(params: {
        formId: string;
        formType: FormDataDownloadType;
        _id: string;
        language?: string;
    }) {
        let organisation = sessionStorage.getItem(`organisationId`);
        let projectId = sessionStorage.getItem(`projectId`);
        let type = 2;
        const token = sessionStorage.getItem('token');
        let url = `${this.base_uri}download.jsonToCsv`;
        const mergedParams = { ...params, type, organisation, token, projectId };

        Object.keys(mergedParams).forEach((key, index) => {
            console.log(index, key);
            if (index === 0) url += `?${key}=${mergedParams[key]}`;
            else url += `&${key}=${mergedParams[key]}`;
        });
        console.log(params, mergedParams, url);
        return url;
    }
    getTempForms(formId = '') {
        return sessionStorage.getItem('projectId')?this.http.get(`${this.base_uri}survey-form-builder/project-forms/${sessionStorage.getItem('projectId')}?form_id=${formId}`, this.auth.setHeaders())
            .map((response: Response) => response.json())
            .map((response: Response) => ({ ...response, data: response['data'].map(form => this.mapSurveyorForms(form)) }))
            .catch(this.handleError): 

            this.http.get(`${this.base_uri}survey-form-builder/project-forms`, this.auth.setHeaders())
            .map((response: Response) => response.json())
            .map((response: Response) => ({ ...response, data: response['data'].map(form => this.mapSurveyorForms(form)) }))
            .catch(this.handleError)
    };
    deleteForm(id) {
        return this.httpClient.delete(`${this.base_uri}survey-form-builder/form-delete/${id}`, this.auth.setHttpHeaders())
            .map((response: any) => response).toPromise();
    }
    setViewSequence(questions, formId) {
        return this.httpClient.post(`${this.base_uri}survey-form-builder/form-question-addSequence/${formId}`, JSON.stringify(questions), this.auth.setHttpHeaders())
            .map((response) => response)
            .catch(this.handleError).toPromise();
    }
    getIndicatorStatus(formId: string) {
        return this.httpClient
            .get(
                `${this.base_uri}data-visualization/get-status/vdpindicators-dashboardindicators/${formId}`,
                this.auth.setHttpHeaders()
            )
            .map(response => response)
            .catch(this.handlehttpError)
            .toPromise();
    }
    uploadTos3(name: string, type: string) {
        name = name.replace(/–/g, '');
        return this.httpClient
            .post(
                this.base_uri + 'getS3Url',
                JSON.stringify([
                    {
                        file_name: name,
                        mime_type: type
                    }
                ]),
                this.auth.setHttpBasicHeaders()
            )
            .map((response: any) => response)
            .catch(this.handlehttpError)
            .toPromise();
    }
    getImageUrl(url, img) {
        const fd = new FormData();
        fd.append('image', img, img['name'].replaceAll(/–/g, ''));
        return this.httpClient
            .put(url, img)
            .map((response: any) => response)
            .catch(this.handlehttpError)
            .toPromise();
    }
    fetchConsentText(url) {
        return fetch(url)
            .then(response => response.text())
            .then(data => data)
            .catch(e => console.log(e));
    }
    publishForms(formId, payload) {
        return this.http.post(this.base_uri + `survey-form-builder/publish-form/${formId}`, JSON.stringify(payload), this.auth.setHeaders())
            .map((response: any) => response.json())
            .catch(this.handleError);
    }
}
